import { useQuery } from "@tanstack/react-query";
import { reportService } from "../../services/report.service";
import { beneficiaryReportParams } from "../../domain/report.interface";

const { getBeneficiaryReport } = reportService;

export const useGetBeneficiaryReport = (
	params: beneficiaryReportParams,
	runReport: boolean,
) => {
	const beneficiaryReport = useQuery({
		queryKey: ["sims-report-beneficiary"],
		queryFn: () => getBeneficiaryReport(params),
		enabled: runReport,
		staleTime: 0,
	});

	return beneficiaryReport;
};

export const useDownloadBeneficiaryReport = (
	params: beneficiaryReportParams,
) => {
	const downloadBeneficiaryReport = useQuery({
		queryKey: ["sims-report-beneficiary-download"],
		queryFn: () => getBeneficiaryReport(params),
		enabled: true,
	});

	return downloadBeneficiaryReport;
};
